import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import Spinner from "../Spinner";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const PopupContainer = styled.div`
  width: 500px;
  max-width: 90%;
  max-height: 90%;
  background: #fff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  animation: ${fadeIn} 0.25s ease;
`;

const TitleBar = styled.div`
  padding: 15px 20px;
  background: #f5f5f5;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #333;
`;

const CloseButton = styled.span`
  cursor: pointer;
  font-size: 20px;
  color: #888;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }
`;

const ImageContainer = styled.div`
  padding: 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.isLoading ? "#fff" : "#fafafa"};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  min-height: 300px;
`;

const AltTextContainer = styled.div`
  min-height: 300px;
  background: #fafafa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
  text-align: center;
`;

const AltText = styled.p`
  color: #666;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 15px;
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 400px;
  border-radius: 8px;
  display: ${props => props.isLoading ? "none" : "block"};
`;

// ImagePopup Component
const ImagePopup = ({ 
  imageUrl, 
  title, 
  isOpen, 
  onClose 
}) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  if (!isOpen) return null;

  const handleImageLoad = () => {
    setImageLoading(false);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <PopupContainer>
        <TitleBar>
          <Title>{title}</Title>
          <CloseButton onClick={onClose}>✖</CloseButton>
        </TitleBar>
        
        <ImageContainer isLoading={imageLoading}>
          {imageLoading && (
            <AltTextContainer>
              <Spinner size="50px" />
            </AltTextContainer>
          )}
          
          {!imageLoading && imageError && (
            <AltTextContainer>
              <div style={{ fontSize: "48px", marginBottom: "10px" }}>🖼️</div>
              <AltText>{title}</AltText>
              <p style={{ color: "#999", marginTop: "10px" }}>تعذر تحميل الصورة</p>
            </AltTextContainer>
          )}
          
          {imageUrl && !imageError && (
            <StyledImage
              src={imageUrl}
              alt={title}
              isLoading={imageLoading}
              onLoad={handleImageLoad}
              onError={handleImageError}
            />
          )}
        </ImageContainer>
      </PopupContainer>
    </ModalOverlay>
  );
};

export default ImagePopup;